const AbstractPayyoRequestRecord = require('./AbstractPayyoRequestRecord');
const { removeNullValues } = require('@/functions/functions');

class PayyoMerchantConfigureTipsRequestRecord extends AbstractPayyoRequestRecord {
    // eslint-disable-next-line camelcase
    constructor(merchantId, data) {
        super(
            'PATCH',
            'merchants/' + merchantId
        );

        const regex = /^mr_[a-zA-Z0-9]{32}$/g;
        if (!merchantId || !merchantId.match(regex)) {
            throw new Error('A valid merchantId is required');
        }

        if (!data) {
            throw new Error('A data object is required');
        }

        this.data = removeNullValues(data, true);
    }
}

module.exports = PayyoMerchantConfigureTipsRequestRecord;
